<template>
    <profile-edit-form-layout :flat="!$device.isDesktop"
                              :title="$t('label.notifications')"
                              no-padding>

        <settings-list>
            <settings-list-item v-for="(item, itemIndex) in items" :key="itemIndex" :to="item.to" :title="item.title" :description="item.description" :icon="item.icon"/>
        </settings-list>
    </profile-edit-form-layout>
</template>

<script setup lang="ts">
import {useManageStore} from "../../../../../../store/manage";

const manageStore = useManageStore();
const {t} = useI18n();
const {$web} = useNuxtApp();

const items = [
	{title: t('label.general'), description: t('view.my.profile.manage.settings.notifications.general.description'), to: $web('my.profile.manage.settings.notifications.general')},
	{title: t('label.athletes'), description: t('view.my.profile.manage.settings.notifications.athletes.description'), to: $web('my.profile.manage.settings.notifications.athletes')},
	{title: t('label.clubs_teams'), description: t('view.my.profile.manage.settings.notifications.clubs.description'), to: $web('my.profile.manage.settings.notifications.clubs')},
	{title: t('label.events'), description: t('view.my.profile.manage.settings.notifications.events.description'), to: $web('my.profile.manage.settings.notifications.events')},
	{title: t('label.devices'), description: t('view.my.profile.manage.settings.notifications.devices.description'), to: $web('my.profile.manage.settings.notifications.devices')},
]

useMeta({
	title: t('view.my.profile.manage.settings.notifications.title'),
	description: t('view.my.profile.manage.settings.notifications.description'),
	noIndex: true
})

</script>

